import { isObject, isArray, isFunction, isPlainObject, mapValues } from 'lodash-es';
import { isProxy, isRef, Ref, toRaw, unref } from 'vue';

/**
 * 对象化结构数据为value
 * {
 *   key: reactive<T> / ref<T>
 * }->
 * {
 *   key: T
 * }
 * @param obj
 */
export function unRefObj(obj: any) {
  if (!obj) return obj;
  const res = {} as any;
  Object.keys(obj).forEach((key) => {
    if (isObject(obj[key]) && !isRef(obj[key]) && !isFunction(obj[key])) {
      res[key] = isArray(obj[key]) ? unref(obj[key]) : unRefObj(obj[key]);
    } else {
      res[key] = isFunction(obj[key]) ? obj[key] : unref(obj[key]);
    }
  });
  return res;
}

export function unRefAndCloneDeep<T>(args: T | Ref<T>): T {
  if (!args) return args;

  const target = isRef(args) ? unref(args) : isProxy(args) ? toRaw(args) : args;

  switch (true) {
    case isArray(target): {
      const list = toRaw(target) as Array<unknown>;
      return list.map((item: unknown) => unRefAndCloneDeep(item)) as T;
    }
    case isPlainObject(target): {
      const record = toRaw(target) as Record<string, unknown>;
      return mapValues(record, (item: unknown) => unRefAndCloneDeep(item)) as T;
    }
    case isProxy(target): {
      return unRefAndCloneDeep(target);
    }
    default:
      return target as T;
  }
}
